import { AdminAction, AdminActionReason, AdminActionsTaken, FullAdminAction } from 'model';
import { BaseApi } from './BaseAPI';

const baseURL = 'adminAction/';
export const ReportApi = BaseApi.injectEndpoints({
	endpoints: builder => ({
		/**
		 * Search admin actions by a create date range and the action taken
		 */
		searchAdminActions: builder.query<
			FullAdminAction[],
			{ startDate: string; endDate: string; actionTaken: AdminActionsTaken }
		>({
			query: ({ startDate, endDate, actionTaken }) => ({
				url: `${baseURL}search/${startDate}/${endDate}/${actionTaken}`
			}),
			providesTags: result =>
				!result ? [] : result?.map(adminAction => ({ type: 'Administrative Action', id: adminAction._id }))
		}),

		/**
		 * Resolve an admin action with the given action taken
		 */
		resolveAdminAction: builder.mutation<
			AdminAction,
			{
				adminActionId: AdminAction['_id'];
				actionTaken: AdminActionsTaken;
				reason: AdminActionReason;
				description: string;
			}
		>({
			query: ({ adminActionId, actionTaken, reason, description }) => ({
				url: `${baseURL}resolve/`,
				method: 'POST',
				body: { adminActionId, actionTaken, reason, description }
			}),
			invalidatesTags: [{ type: 'Administrative Action' }]
		})
	})
});

export const { useSearchAdminActionsQuery, useResolveAdminActionMutation } = ReportApi;
